import { render, staticRenderFns } from "./ChoiceButton.vue?vue&type=template&id=3b0094a1&scoped=true&"
import script from "./ChoiceButton.vue?vue&type=script&lang=js&"
export * from "./ChoiceButton.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceButton.vue?vue&type=style&index=0&id=3b0094a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0094a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
